import axios from '../helpers/axios'
import { logError } from '../services';
import { IPlanRoomCategory, IPlanRoomsResponse } from '../models';

const baseUrl = "/api/plan-rooms";

export const getAdminPlanRooms = async (filters?: {
  page?: number;
  perPage?: number;
  sortBy?: string;
}): Promise<IPlanRoomsResponse> => {
    try {
        const { data } = await axios.get(`${baseUrl}`, { params: filters });
    return data;
    } catch (error) {
    logError(error, 'getPlanRooms failed');
    return Promise.reject(error);
  }
};

export const postPlanRoom = async (name, category): Promise<any> => {
  try {
      const { data } = await axios.post(`${baseUrl}`, { name, category });
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          name,
          category
        }
      },
      'postPlanRoom failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const deletePlanRoom = async (id): Promise<number> => {
    try {
      const { data } = await axios.delete(`${baseUrl}/${id}`);
    return data;
  } catch (error) {
    logError(error, 'deletePlanRoom failed');
    return Promise.reject(error);
  }
};

export const getPlanRoomCategories = async (): Promise<IPlanRoomCategory[]> => {
  try {
      const { data } = await axios.get(`${baseUrl}/categories`);
    return data;
  } catch (error) {
    logError(error, 'getPlanRoomCategories failed');
    return Promise.reject(error);
  }
};
